import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-arrow-upload",
  "use": "default-arrow-upload-usage",
  "viewBox": "0 0 16 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 22\" id=\"default-arrow-upload\"><g fill-rule=\"evenodd\"><rect x=\"7\" y=\"1\" width=\"2\" height=\"16\" rx=\"1\" /><rect transform=\"rotate(-45 11.64 4.725)\" x=\"10.639\" y=\"-.775\" width=\"2\" height=\"11\" rx=\"1\" /><rect transform=\"scale(-1 1) rotate(-45 0 15.925)\" x=\"3.639\" y=\"-.775\" width=\"2\" height=\"11\" rx=\"1\" /><rect y=\"20\" width=\"16\" height=\"2\" rx=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol